import { CsvDto } from "src/types/csv.dto";

export const downloadCsvFile = (data: CsvDto) => {
  // Add link element to DOM
  const url = data.download_url;
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", data.platform); // Set the filename for the download

  // Append link
  document.body.appendChild(link);

  // Click link
  link.click();
  link.remove();

  window.URL.revokeObjectURL(url);
};
